import { Grid } from "@material-ui/core";
import { FunctionComponent } from "react";
import styled from "styled-components";
import { H1 } from "../../components/typography";
import { Widget } from "../../components/widget";
import { WalletsDTO } from "../../store/wallets/models/dto";

const StyledWidget = styled(Widget)`
  &:not(:last-child) {
    margin-bottom: 1em;
  }
`;

export const SingleWallet: FunctionComponent<{
  id: string;
  item: WalletsDTO.Responses.GetSingle.T;
}> = ({ item }) => {
  const { id } = item;

  // const formattedDate = useMemo(
  //   () => moment.utc(createdDate).local().format("yyyy-MM-DD HH:mm"),
  //   [createdDate]
  // );

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <StyledWidget title="Overview">
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <H1>{id}</H1>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}></Grid>
            </Grid>
          </StyledWidget>
        </Grid>
      </Grid>
    </>
  );
};
